import React, { useEffect } from 'react';
import { IDefaultResponsiveSupport } from '../../../common/interfaces/common.interface';

interface ResumePDFProps extends IDefaultResponsiveSupport {}
const ResumePDF: React.FC<ResumePDFProps> = () => {
  useEffect(() => {
    if (/Android|iPhone|iPad/i.test(navigator.userAgent)) {
      window.open('/resume.pdf', '_blank');
    }
  }, []);

  return (
    <iframe
      src="/resume.pdf"
      width="100%"
      style={{ border: 'none' }}
      title="Resume"
      height={'100%'}
    />
  );
};

export default ResumePDF;
